import React from 'react';
import MainQuestion from "./MainQuestion";
import QuestionOptions from "./QuestionOptions";
import AdditionalQuestionOptions from "./AdditionalQuestionOptions";
import AdditionalQuestion from "./AdditionalQuestion";
import ReadingMainQuestion from "./ReadingMainQuestion";
import ConversationMainQuestion from "./ConversationMainQuestion";
import MatchQuestion from "./MatchQuestion";
import FillGapQuestion from "./FillGapQuestion";

class QuestionBody extends React.Component{

    constructor(props) {
        super(props);
        this.optionRef = React.createRef();
    }

    render(){
        let records = this.props.frageBody;
        if (records.questionType === '1') {
            if(records.additionalQuestion=="") {
                return (
                    <div className="questionBody">
                        <MainQuestion frageTitle={this.props.frageBody.questionTitle}/>
                        <QuestionOptions
                            frageOptions={this.props.frageBody.options}
                            multipleQ={this.props.frageBody.multipleQuestions}
                            setResult={this.props.setResult}
                            setAdditionalResult={this.props.setAdditionalResult}
                           /* ref={this.props.setRef}*/
                            /*getSelectedAnswer={this.props.frageBody.getSelectedAnswer}*/
                           /* ref={this.optionRef}*/
                            /*updateSelctionResultArr={this.props.updateSelctionResultArr}*/
                           />
                    </div>
                )
            }else {
                return(
                    <div className="questionBody">
                        <MainQuestion frageTitle={this.props.frageBody.questionTitle}/>
                        <QuestionOptions
                            frageOptions={this.props.frageBody.options}
                            multipleQ={this.props.frageBody.multipleQuestions}
                            setResult={this.props.setResult}
                            setAdditionalResult={this.props.setAdditionalResult}
                            /*getSelectedAnswer={this.props.frageBody.getSelectedAnswer}*/
                            /*ref={this.optionRef}*/
                            /*updateSelctionResultArr={this.props.updateSelctionResultArr()}*//>
                        <AdditionalQuestion frageTitle={this.props.frageBody.additionalQuestion}/>
                        <AdditionalQuestionOptions frageOptions={this.props.frageBody.additionalAnswer}
                                                   multipleQ={this.props.frageBody.multipleQuestions}
                                                   setResult={this.props.setResult}
                                                    setAdditionalResult={this.props.setAdditionalResult} />
                       {/* <QuestionOptions
                            frageOptions={this.props.frageBody.additionalAnswer}
                            multipleQ={this.props.frageBody.multipleQuestions}
                            setResult={this.props.setResult}
                            setAdditionalResult={this.props.setAdditionalResult}
                         />*/}
                    </div>
                )
            }
        }else if(records.questionType === '0') {
           /* console.log(records.questionTitle.length)*/

                    if (records.multipleChoiceQues != "1") {
                        return (
                            <div className="questionBody">
                                <ReadingMainQuestion frageTitle={this.props.frageBody.questionTitle}/>
                                {/* <QuestionOptions frageOptions={this.props.frageBody.options}/>*/}
                                <QuestionOptions
                                    frageOptions={this.props.frageBody.options}
                                    multipleQ={this.props.frageBody.multipleQuestions}
                                    /*getSelectedAnswer={this.props.frageBody.getSelectedAnswer}*/
                                    setResult={this.props.setResult}
                                    setAdditionalResult={this.props.setAdditionalResult}/>
                            </div>
                        );
                    } else {
                        return (
                            <div className="questionBody">
                                <MatchQuestion
                                    frageTitle={this.props.frageBody.questionTitle}
                                    frageOptions={this.props.frageBody.options}
                                    additionalFrageTitle={this.props.frageBody.additionalQuestion}
                                    setResult={this.props.setResult}
                                    setAdditionalResult={this.props.setAdditionalResult}/>
                            </div>
                        );


                    }


        }else if(records.questionType === '2'){
            if(records.dragDropQuestion==="1") {

                return (
                    <div className="questionBody">
                        <ConversationMainQuestion
                            frageTitle={this.props.frageBody.questionTitle}
                            frageOptions={this.props.frageBody.options}
                            setResult={this.props.setResult}
                            setAdditionalResult={this.props.setAdditionalResult}
                        />
                        {/*<QuestionOptions frageOptions={this.props.frageBody.options}/>*/}
                    </div>
                );
            }else if(records.gapQuestion==="1"){
                return (
                    <div className="questionBody">
                        <FillGapQuestion frageTitle={this.props.frageBody.questionTitle}
                                         frageOptions={this.props.frageBody.options}
                                         setResult={this.props.setResult}
                                         setAdditionalResult={this.props.setAdditionalResult}/>
                    </div>
                );
            }
        }else{
            return(
                <div className="questionBody"></div>
            )
        }
    }
}
export default QuestionBody;
